import AddIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import { Toolbar } from "@mui/x-data-grid-premium";

interface Props {
  addRowDisabled?: boolean;
  onAddRowClick: () => void;
}

const DataImportChangesGridToolbar = ({ addRowDisabled, onAddRowClick }: Props) => {
  return (
    <Toolbar>
      <Button variant="text" startIcon={<AddIcon />} onClick={onAddRowClick} disabled={addRowDisabled}>
        Add row
      </Button>
    </Toolbar>
  );
};

export default DataImportChangesGridToolbar;
